/**
 * Each module in this file should be considered independent of
 * templates or individual routes. Instead, each module should be
 * dynamically imported based on a test criteria such as the
 * presence of a DOM element with a given data attribute.
 */

export const modules: Module[] = [
  {
    selector: '[data-module="home-hero"]',
    exportedFunction: 'homeHero',
    fileName: 'home-hero'
  },
  {
    selector: '[data-module="stacked-section"]',
    exportedFunction: 'StackedSection',
    fileName: 'stacked-section'
  },
  {
    selector: '[data-module="project-slider"]',
    exportedFunction: 'ProjectSlider',
    fileName: 'project-slider'
  },
  {
    selector: '[data-module="testimonial-slider"]',
    exportedFunction: 'TestimonialSlider',
    fileName: 'testimonial-slider'
  },
  {
    selector: '[data-module="gallery"]',
    exportedFunction: 'Gallery',
    fileName: 'gallery'
  },
  {
    selector: '[data-module="timeline"]',
    exportedFunction: 'Timeline',
    fileName: 'timeline'
  },
  {
    selector: '[data-animation="hero-animate-up"]',
    exportedFunction: 'HeroAnimateUp',
    fileName: 'text-animate-up'
  },
  {
    selector: '[data-animation="heading-animate-up"]',
    exportedFunction: 'HeadingAnimateUp',
    fileName: 'text-animate-up'
  },
  {
    selector: '[data-animation="hero-parallax"]',
    exportedFunction: 'HeroParallax',
    fileName: 'image-parallax'
  },
  {
    selector: '[data-animation="image-parallax"]',
    exportedFunction: 'ImageParallax',
    fileName: 'image-parallax'
  },
  {
    selector: '[data-animation="icon-parallax"]',
    exportedFunction: 'IconParallax',
    fileName: 'image-parallax'
  },
  {
    selector: '[data-animation="card-reveal"]',
    exportedFunction: 'CardAnimateRight',
    fileName: 'card-reveals'
  },
  {
    selector: '[data-ajax="team-loadmore"]',
    exportedFunction: 'TeamLoadmore',
    fileName: 'ajax'
  },
  {
    selector: '[data-module="facet-wp-events"]',
    exportedFunction: 'FacetWpEvents',
    fileName: 'facet-wp-events'
  }
]

interface Module {
  /** The CSS selector used to identify the module in the HTML. */
  selector: string

  /** The name of the function that the module exports */
  exportedFunction: string

  /** The file name that contains the module's code, without an extension. This should be a .js or .ts file */
  fileName: string
}
